import { Command } from 'cmdk';
import React from 'react';

function CmdkItem({
  children,
  shortcut,
  onSelect = () => {},
  value,
  className
}: {
  children: React.ReactNode;
  shortcut?: string;
  onSelect?: (value: string) => void;
  value?: string;
  className?: string;
}) {
  return (
    <Command.Item className={className} onSelect={onSelect} value={value}>
      {children}
      {shortcut && (
        <div cmdk-vercel-shortcuts=''>
          {shortcut.split(' ').map((key) => {
            return <kbd key={key}>{key}</kbd>;
          })}
        </div>
      )}
    </Command.Item>
  );
}

export default CmdkItem;
